import { GraphApiService } from '@nuso/common/data-access-api';
import { Injectable, inject } from '@angular/core';
import {
  getIamGroupByIdQuery,
  createIamGroupMutation,
  deleteIamGroupMutation,
  updateIamGroupMutation,
  getIamGroupsQuery,
} from './iam-group.queries';
import { Group } from '@nuso/iam/types';

@Injectable({
  providedIn: 'root',
})
export class IamGroupService {
  private graphApi = inject(GraphApiService);


  getAllGroups() {
    return this.graphApi.watchQuery<{ totalCount: number, groups: Group[] }>({
      fetchPolicy: 'network-only',
      query: getIamGroupsQuery,
      variables: {
        input: {
          limit: 9999, // Don't really paginate here, as this is for dropdowns... but at least put some arbitrary limit
        },
      },
    });
  }

  getGroupsAvailableForAppUser(appUserId: string) {
    return this.graphApi.watchQuery<{ totalCount: number, groups: Group[] }>({
      fetchPolicy: 'network-only',
      query: getIamGroupsQuery,
      variables: {
        input: {
          limit: 9999, // Don't really paginate here, as this is for dropdowns... but at least put some arbitrary limit
          notAppUserId: appUserId,
        },
      },
    });
  }

  fetchGroup(groupId: string) {
    return this.graphApi.watchQuery<Group>({
      fetchPolicy: 'network-only',
      query: getIamGroupByIdQuery,
      variables: {
        input: {
          id: groupId,
        },
      },
    });
  }

  createGroup(group: Group) {
    return this.graphApi.mutate({
      mutation: createIamGroupMutation,
      variables: {
        input: {
          name: group.name,
          description: group.description,
        },
      },
    });
  }

  updateGroup(group: Group) {
    const { id, name, description } = group;

    return this.graphApi.mutate({
      mutation: updateIamGroupMutation,
      variables: {
        input: {
          id,
          name,
          description,
        },
      },
    });
  }

  deleteGroup(groupId: string) {
    return this.graphApi.mutate({
      mutation: deleteIamGroupMutation,
      variables: {
        input: {
          id: groupId,
        },
      },
    });
  }
}
